module.exports = __webpack_public_path__ + "assets/img/step5-sz.c12d7881.png";